var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"auth-register-container"},[_c('keep-alive',[_c(_vm.activeComponent,{tag:"component",on:{"setActiveComponent":_vm.setActiveComponent}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }